import { render, staticRenderFns } from "./agree-fqxk.vue?vue&type=template&id=c619168a&scoped=true"
import script from "./agree-fqxk.vue?vue&type=script&lang=ts"
export * from "./agree-fqxk.vue?vue&type=script&lang=ts"
import style0 from "./agree-fqxk.vue?vue&type=style&index=0&id=c619168a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c619168a",
  null
  
)

export default component.exports